/* eslint-disable import/no-cycle */
/**
 * @overview Search page cuisine filter behaviour.
 *
 * @module search/cuisines
 */

import $ from 'qwery';
import scrollTo from 'scroll-to';
import { collapseList } from '../../modules/controlList';
import { selectAllCheckboxActions } from '../../helpers/checkboxHelper';
import { positionCuisines } from './positionCuisines';
import { filterRestaurants, setActiveItems } from './filtering';
import { addSortIndex } from './helpers';


/**
 * Get the toal count for matched cuisines.
 *
 * @param {object[]} cuisines
 * @param {string} cuisine
 * @returns {number}
 */
function getCuisineCount (cuisines, cuisine) {
    const result = cuisines.find(c => c.cuisine === cuisine);
    return result ? result.count : 0;
}

/**
 * Enable or disable a cuisine filter.
 *
 * @param {Node} cuisineFilter
 * @param {boolean} disable
 */
function enableCuisine (cuisineFilter, disable) {
    const input = cuisineFilter.querySelector('input');

    if (disable) {
        input.checked = false;
        input.disabled = true;
        cuisineFilter.classList.add('is-inactive');
    } else {
        input.disabled = false;
        cuisineFilter.classList.remove('is-inactive');
    }
}

/**
 * Update the cuisine filters on the page.
 *
 * @param {object[]} cuisines
 */
export function updateCuisines (cuisines) {
    if (cuisines) {
        const cuisineFilters = $('[data-cuisine-filter-item]');

        cuisineFilters.forEach(cuisineFilter => {
            const seoName = cuisineFilter.getAttribute('data-seo-name');
            const total = getCuisineCount(cuisines, seoName);
            const shouldDisable = total < 1;

            cuisineFilter.querySelector('[data-cuisine-total]').innerHTML = total;
            enableCuisine(cuisineFilter, shouldDisable);
        });

        setActiveItems(cuisineFilters);
    }
}

/**
 * Cuisine selected events.
 *
 * @param {string|Node} context
 * @param {boolean} [filtered=false] Indicates whether the results were successfully filtered
 * @param {boolean} [scrollToTop=false] Scroll the user to the top of page?
 */
function cuisineSelected (context, { filtered = false, scrollToTop = false } = {}) {
    if (filtered) {
        positionCuisines(context, { withCheckboxValidation: false });

        if (scrollToTop) {
            const list = $('[data-cuisine-filter][data-expandable]')[0];

            scrollTo(0, 0, {
                ease: 'in-out-quart',
                duration: 750
            });

            if (list) {
                collapseList(list);
            }
        }
    }
}

/**
 * Bind filter events.
 *
 * @param {Node} filter
 * @param {string|Node} context
 * @param {boolean} applyFilter - Should the restaurant results be filtered?
 */
function bindFilterEvents (filter, context, applyFilter) {
    const controlInput = $('.control-input', filter);
    if (controlInput.length > 0) {
        controlInput[0].addEventListener('change', e => {
            e.preventDefault();

            const checkboxValue = e.target.value;

            selectAllCheckboxActions(checkboxValue, { context });

            if (applyFilter) {
                const scrollToTop = !!e.target.closest('.is-hideable');
                filterRestaurants({ scrollToTop });
            }
        });
    }
}

/**
 * Bind cuisine events.
 *
 * @param {string|Node} context
 * @param {boolean} [applyFilter=true] Should the restaurant results be filtered?
 * @param {boolean} [shouldPositionCuisines=true] Add a record to the browser history?
 */
export function bindCuisineEvents (context, { applyFilter = true, shouldPositionCuisines = true } = {}) {
    const filters = $('.controlList-item', context);

    if (filters.length > 0) {
        filters.forEach(addSortIndex);
        filters.forEach(filter => bindFilterEvents(filter, context, applyFilter));

        if (shouldPositionCuisines) {
            positionCuisines(context);
        }
    }

    document.addEventListener('serpFiltered', e => {
        const { filtered, scrollToTop } = e.detail;
        cuisineSelected(context, { filtered, scrollToTop });
    });
}

(function initCuisines () {
    bindCuisineEvents('[data-cuisine-filter]');
}());
